import { Action } from '@ngrx/store';
import { Site } from '../site/site.model';

export enum SiteApiActionTypes {
  LoadSitesApi = '[Site API] Load Sites',
  LoadSitesSuccessApi = '[Site API] Load Sites Success',
  LoadSitesFailureApi = '[Site API] Load Sites Failure',
  LoadSiteApi = '[Site API] Load Site',
  LoadSiteSuccessApi = '[Site API] Load Site Success',
  LoadSiteFailureApi = '[Site API] Load Site Failure',
  CreateSiteApi = '[Site API] Create Site',
  CreateSiteSuccessApi = '[Site API] Create Site Success',
  CreateSiteFailureApi = '[Site API] Create Site Failure',
  UpdateSiteApi = '[Site API] Update Site',
  UpdateSiteSuccessApi = '[Site API] Update Site Success',
  UpdateSiteFailureApi = '[Site API] Update Site Failure',
  DeleteSiteApi = '[Site API] Delete Site',
  DeleteSiteSuccessApi = '[Site API] Delete Site Success',
  DeleteSiteFailureApi = '[Site API] Delete Site Failure',
}

export class LoadSitesApi implements Action {
  readonly type = SiteApiActionTypes.LoadSitesApi;
  constructor(public payload: { params: any } = { params: {} }) {}
}

export class LoadSitesSuccessApi implements Action {
  readonly type = SiteApiActionTypes.LoadSitesSuccessApi;
  constructor(public payload: { sites: Site[] }) {}
}

export class LoadSitesFailureApi implements Action {
  readonly type = SiteApiActionTypes.LoadSitesFailureApi;
  constructor(public payload: { message: string }) {}
}

export class LoadSiteApi implements Action {
  readonly type = SiteApiActionTypes.LoadSiteApi;
  constructor(public payload: { id: string }) {}
}

export class LoadSiteSuccessApi implements Action {
  readonly type = SiteApiActionTypes.LoadSiteSuccessApi;
  constructor(public payload: { site: Site }) {}
}

export class LoadSiteFailureApi implements Action {
  readonly type = SiteApiActionTypes.LoadSiteFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class CreateSiteApi implements Action {
  readonly type = SiteApiActionTypes.CreateSiteApi;
  constructor(public payload: { site: Site }) {}
}

export class CreateSiteSuccessApi implements Action {
  readonly type = SiteApiActionTypes.CreateSiteSuccessApi;
  constructor(public payload: { site: Site }) {}
}

export class CreateSiteFailureApi implements Action {
  readonly type = SiteApiActionTypes.CreateSiteFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class UpdateSiteApi implements Action {
  readonly type = SiteApiActionTypes.UpdateSiteApi;
  constructor(public payload: { site: Site }) {}
}

export class UpdateSiteSuccessApi implements Action {
  readonly type = SiteApiActionTypes.UpdateSiteSuccessApi;
  constructor(public payload: { site: Site }) {}
}

export class UpdateSiteFailureApi implements Action {
  readonly type = SiteApiActionTypes.UpdateSiteFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class DeleteSiteApi implements Action {
  readonly type = SiteApiActionTypes.DeleteSiteApi;
  constructor(public payload: { id: string }) {}
}

export class DeleteSiteSuccessApi implements Action {
  readonly type = SiteApiActionTypes.DeleteSiteSuccessApi;
  constructor(public payload: { id: string }) {}
}

export class DeleteSiteFailureApi implements Action {
  readonly type = SiteApiActionTypes.DeleteSiteFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export type SiteApiActions =
  | LoadSitesApi
  | LoadSitesSuccessApi
  | LoadSitesFailureApi
  | LoadSiteApi
  | LoadSiteSuccessApi
  | LoadSiteFailureApi
  | CreateSiteApi
  | CreateSiteSuccessApi
  | CreateSiteFailureApi
  | UpdateSiteApi
  | UpdateSiteSuccessApi
  | UpdateSiteFailureApi
  | DeleteSiteApi
  | DeleteSiteSuccessApi
  | DeleteSiteFailureApi;
